/* eslint-disable import/prefer-default-export */

export const snakeToKebab = (text) => text.replace(/_/g, '-');

// Escapes special characters for use in a regular expression
export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  return JSON.parse(JSON.stringify(obj));
};

export const snakeToCapitalized = (text) =>
  text && typeof text === 'string'
    ? text
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';
